// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--f8BR2";
export var footerContainer = "footer-module--footer-container--pVzhp";
export var footerText = "footer-module--footer-text--1lXQQ";
export var footerContacts = "footer-module--footer-contacts--57P2V";
export var footerContact = "footer-module--footer-contact--_SNxI";
export var footerLogo = "footer-module--footer-logo--2RBRE";
export var footerLinks = "footer-module--footer-links--36Ax7";
export var footerFlex = "footer-module--footer-flex--3_CXC";
export var footerBottom = "footer-module--footer-bottom--29Z17";
export var footerBox = "footer-module--footer-box--Xwkvd";